import React, { Component } from "react";
import BackgroundSlider from 'react-background-slider'

import Headbody from "../../components/head-body";
import Menu from "../../components/menu";
import Devsolucoes from "../../components/dev-solucoes";
import Footer from "../../components/footer";
import Endbody from "../../components/end-body";

import image1 from '../../assets/img/solucoes/img-solucoes_gestao-de-processo-0.jpg'
import image2 from '../../assets/img/solucoes/img-solucoes_gestao-de-processo-01.jpg'
import image3 from '../../assets/img/solucoes/img-solucoes_gestao-de-processo-02.jpg'


class Limpeza extends Component {
  
    render() {
      return (
          <React.Fragment>
                <Headbody></Headbody>
                <Menu></Menu>
                <section class="header-interno padrao">
                  <div class="container">
                    <div class="row">
                      <div class="col-12 col-lg-8">
                        <h2>Itech<span class="azul">Flow</span></h2>
                        <h3>Solução para Gestão de processo de limpeza</h3>
                        <span class="saude">Saúde</span> <span class="hotelaria">Hotelaria</span>
                      </div>
                    </div>
                  </div>
                </section>

                <section class="conteudo-interno">
                  <div class="container">
                    <div class="row d-lg-flex align-items-lg-center">
                      <div class="col-12 col-lg-6">
                        {/* <div id="galeria" class="owl-carousel">
                          <img src={"../assets/img/solucoes/img-solucoes_gestao-de-processo-0.jpg"} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img>
                          <img src={"../assets/img/solucoes/img-solucoes_gestao-de-processo-01.jpg"} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img>
                          <img src={"../assets/img/solucoes/img-solucoes_gestao-de-processo-02.jpg"}class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img>
                          </div> */}
                          <div style={{width: '480px', height: '400px'}} class="img-fluid m-auto" >
                              <BackgroundSlider
                                  images={[image1, image2, image3]}
                                  duration={5}
                                  transition={0.5}
                              />
                              {/* <img src={image1} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img> */}
                          </div>
                      </div>

                      <div class="col-12 col-lg-6">
                        <h3>Descrição:</h3>
                        {/* <p>O Módulo de Gestão Limpeza foi desenvolvido com o objetivo de facilitar e acelerar o controle no processo de limpeza de leitos, centros cirúrgicos e áreas comuns em hospitais/laboratórios/clínicas. Através dele conseguimos monitorar todos os recursos envolvidos nesse processo, bem como garantir que toda a rotina foi realizada com eficácia, não só na limpeza, mas também na manutenção ecessária para a operação. Através de check-list, podemos disparar OS (ordem de serviço) para várias áreas e atribuir responsáveis para execução das tarefas. Nossa solução está preparada para monitorar todas as OS abertas/Encerradas com status para cada tipo de atividade. Controlamos em tempo real através de conexão por aplicativo em tablets e smartphones. Método de visualização por dash-board com vários níveis de visualização.</p> */}
                            <p>O Módulo de Gestão Limpeza foi desenvolvido com o objetivo de facilitar e acelerar o controle no processo de limpeza de leitos, centros cirúrgicos e áreas comuns em hospitais/laboratórios/clínicas. Através dele conseguimos monitorar todos os recursos envolvidos nesse processo, bem como garantir que toda a rotina foi realizada com eficácia, não só na limpeza, mas também na manutenção necessária para a operação. Através de check-list, podemos disparar OS (ordem de serviço) para várias áreas e atribuir responsáveis para execução das tarefas. Nossa solução está preparada para monitorar todas as OS abertas/Encerradas com status para cada tipo de atividade. Controlamos em tempo real através de conexão por aplicativo em tablets e smartphones, além disso, disponibilizamos gestão a vista das informações e também dashboard gerencial.</p>
                        <iframe width="100%" height="300" src="https://www.youtube.com/embed/pBvF5EsvoJ4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                      </div>
                      </div>

                      <div class="row">

                      <div class="col-12 mt-5">
                        <h3>Aplicação:</h3>
                        <p>Hospitais, serviços de hotelaria, etc... Clínicas diagnósticas, laboratórios.</p> 
                        
                        <h3>Principais funcionalidades e benefícios:</h3>
                      </div>


                      <div class="col-12 col-md-6">
                        <ul>
                          {/* <li>Controle de atividades em tempo real do processo e produtividade de equipe;</li>
                          <li>Visibilidade por setor, andar, áreas, salas, leitos, etc..;</li>
                          <li>Controle de tempos por atividade;</li>
                          <li>Controle através de dash-board;</li>
                          <li>Redução no intervalo de ocupação e desocupação de leitos e centros cirúrgicos;</li> */}
                          <li>Controle de atividades em tempo real do processo e produtividade de equipe;</li>
                          <li>Gestão a vista, permitindo visibilidade por setor, andar, áreas, salas, leitos, etc..;</li>
                          <li>Controle de tempos por atividade;</li>
                          <li>Geração de relatórios e dashboard;</li>
                          <li>Redução no intervalo de ocupação e desocupação de leitos e centros cirúrgicos;</li>
                          <li>Liberação automática de leitos através de interface com ERPs TASY e MV</li>
                          <li>Geração de Os para várias áreas e responsáveis para execução das tarefas.</li>
                        </ul>
                      </div>

                      <div class="col-12 col-md-6">
                        <ul>
                          {/* <li>Melhor gestão no controle de limpeza;</li>
                          <li>Baixo custo de operacionalização;</li>
                          <li>Geração automática de relatórios;</li>
                          <li>Armazenamento de informações;</li>
                          <li>Liberação automática de leitos para ERPs TASY e MV</li> */}
                          <li>Fácil visualização do processo através de Dashboard;</li>
                          <li>Tabelas com detalhamento de cada procedimento de limpeza.</li>
                          <li>Aplicativo personalizado para tablets e smartphones sem limite de usuários.</li>
                          <li>Mais qualidade dos serviços pela padronização e obrigatoriedade de checklist detalhado.</li>
                          <li>Armazenamento de informações em nuvem;</li>
                          <li>Contribui para a redução tempo de liberação e aumento da disponibilidade de quartos, leitos e centros cirúrgicos;</li>
                        </ul>

                        <br></br><br></br>
                      </div>
                      <div class="col-12 text-center" >
                          <a href={"../pdf/catalogo-limpeza.pdf"} class="btn-itm" target="_blank">Baixar Catálogo</a>
                          <br></br><br></br>
                      </div>
                      
                        {/* <div class="col-12 col-lg-5">
                        </div>

                        <div class="col-12 col-lg-7">
                          
                        </div> */}
                      
                    </div>
                  </div>
                </section>
            
                <Devsolucoes></Devsolucoes>
                <Footer></Footer>
                <Endbody></Endbody>
          </React.Fragment>
        
      );
    }
  }

export default Limpeza;